import { render, staticRenderFns } from "./ModalConvidarSignatarios.vue?vue&type=template&id=1374f65c&"
import script from "./ModalConvidarSignatarios.vue?vue&type=script&lang=js&"
export * from "./ModalConvidarSignatarios.vue?vue&type=script&lang=js&"
import style0 from "./ModalConvidarSignatarios.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VIcon,VTextField})
